import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { RecipientsManage } from '@/features/recipients/RecipientsManage';
import { useTenant } from '@/lib/tenant';

function RecipientsRoute() {
  const { slug } = Route.useParams();
  const { setSlug } = useTenant();
  useEffect(() => {
    setSlug(slug);
  }, [slug, setSlug]);
  return <RecipientsManage slug={slug} />;
}

export const Route = createFileRoute('/tenants/$slug/recipients')({
  component: RecipientsRoute,
});
